let newsPublicPage = 1;
let newsPublicPerPage = 12;
let newsPublicTotal = 0;
let newsPublicSearchTimer = null;
let newsPublicLastQuery = '';

function escapeNewsAttr(s) {
    if (s == null) {
        return '';
    }
    return String(s)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function formatNewsDate(iso) {
    if (!iso) {
        return '';
    }
    const d = new Date(String(iso).replace(' ', 'T'));
    if (isNaN(d.getTime())) {
        return String(iso);
    }
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
}

function buildNewsListUrl() {
    const q = new URLSearchParams();
    q.set('page', String(newsPublicPage));
    q.set('per_page', String(newsPublicPerPage));
    const s = ($('#newsSearch').val() || '').trim();
    if (s) {
        q.set('q', s);
    }
    return '/api/newsPosts/list?' + q.toString();
}

function renderNewsGrid(posts) {
    const $grid = $('#newsGrid');
    if (!posts || posts.length === 0) {
        $grid.html(
            '<div class="col-12 text-center py-5 text-muted">' +
                '<i class="fa-solid fa-inbox fa-3x mb-3 d-block opacity-50"></i>' +
                '<p class="mb-0">No articles match your search.</p>' +
                '</div>'
        );
        return;
    }
    const fallbackImg = '/assets/img/company/not_available.webp';
    let html = '';
    posts.forEach(function (p) {
        const title = p.title != null ? String(p.title) : '';
        const slug = p.slug != null ? String(p.slug) : '';
        const excerpt = p.excerpt != null && String(p.excerpt).trim() !== '' ? String(p.excerpt) : '';
        const img = p.featured_image_url ? String(p.featured_image_url) : fallbackImg;
        const dateStr = formatNewsDate(p.published_at);
        const titleEsc = typeof escapeHtml === 'function' ? escapeHtml(title) : escapeNewsAttr(title);
        const excerptEsc = typeof escapeHtml === 'function' ? escapeHtml(excerpt) : escapeNewsAttr(excerpt);
        html +=
            '<div class="col-md-6 col-lg-4">' +
            '<div class="card border-0 shadow-sm h-100">' +
            '<a href="/news/' +
            encodeURIComponent(slug) +
            '" class="text-decoration-none text-dark">' +
            '<img src="' +
            escapeNewsAttr(img) +
            '" class="card-img-top" alt="' +
            escapeNewsAttr(title) +
            '" style="height: 220px; object-fit: cover;" loading="lazy">' +
            '</a>' +
            '<div class="card-body d-flex flex-column">' +
            '<small class="text-muted d-block mb-2"><i class="fa fa-calendar me-1"></i> ' +
            escapeNewsAttr(dateStr) +
            '</small>' +
            '<h5 class="fw-semibold">' +
            '<a href="/news/' +
            encodeURIComponent(slug) +
            '" class="text-decoration-none text-dark">' +
            titleEsc +
            '</a></h5>' +
            '<p class="text-muted small mb-3 flex-grow-1">' +
            (excerptEsc || '<span class="text-muted">Read more…</span>') +
            '</p>' +
            '<a href="/news/' +
            encodeURIComponent(slug) +
            '" class="btn btn-outline-primary rounded-pill w-100 mt-auto">Read more</a>' +
            '</div></div></div>';
    });
    $grid.html(html);
}

function renderNewsPagination() {
    const totalPages = Math.max(1, Math.ceil(newsPublicTotal / newsPublicPerPage));
    const $p = $('#newsPagination');
    $p.empty();
    if (newsPublicTotal === 0) {
        return;
    }
    if (totalPages <= 1) {
        return;
    }

    function addItem(label, page, disabled, active) {
        const liClass =
            'page-item' +
            (disabled ? ' disabled' : '') +
            (active ? ' active' : '');
        const href = disabled || active ? '#' : '#';
        $p.append(
            '<li class="' +
                liClass +
                '"><a class="page-link" href="' +
                href +
                '" data-page="' +
                page +
                '">' +
                label +
                '</a></li>'
        );
    }

    if (newsPublicPage > 1) {
        addItem('<i class="fa-solid fa-chevron-left"></i>', newsPublicPage - 1, false, false);
    }

    const maxVis = 5;
    let start = Math.max(1, newsPublicPage - Math.floor(maxVis / 2));
    let end = Math.min(totalPages, start + maxVis - 1);
    if (end - start < maxVis - 1) {
        start = Math.max(1, end - maxVis + 1);
    }

    for (let i = start; i <= end; i++) {
        addItem(String(i), i, false, i === newsPublicPage);
    }

    if (newsPublicPage < totalPages) {
        addItem('<i class="fa-solid fa-chevron-right"></i>', newsPublicPage + 1, false, false);
    }
}

function updateNewsMeta() {
    const $m = $('#newsResultsMeta');
    if (newsPublicTotal === 0) {
        $m.text('No articles');
        return;
    }
    const start = (newsPublicPage - 1) * newsPublicPerPage + 1;
    const end = Math.min(newsPublicPage * newsPublicPerPage, newsPublicTotal);
    $m.text('Showing ' + start + '–' + end + ' of ' + newsPublicTotal + ' articles');
}

function loadNewsPage() {
    const $grid = $('#newsGrid');
    $grid.html(
        '<div class="col-12 text-center py-5 text-muted">' +
            '<span class="spinner-border spinner-border-sm me-2"></span>Loading…</div>'
    );
    $.ajax({
        url: buildNewsListUrl(),
        method: 'GET',
        dataType: 'json',
        success: function (res) {
            if (!res || !res.success || !Array.isArray(res.posts)) {
                $grid.html(
                    '<div class="col-12 text-center py-5 text-danger">Could not load news.</div>'
                );
                return;
            }
            newsPublicTotal = typeof res.total === 'number' ? res.total : res.posts.length;
            newsPublicPage = typeof res.page === 'number' ? res.page : newsPublicPage;
            newsPublicPerPage = typeof res.per_page === 'number' ? res.per_page : newsPublicPerPage;
            renderNewsGrid(res.posts);
            renderNewsPagination();
            updateNewsMeta();
            if (newsPublicPage > 1) {
                $('html, body').animate({ scrollTop: $('#newsGrid').offset().top - 80 }, 300);
            }
        },
        error: function () {
            $grid.html(
                '<div class="col-12 text-center py-5 text-danger">Could not load news.</div>'
            );
        }
    });
}

function scheduleNewsSearch() {
    clearTimeout(newsPublicSearchTimer);
    newsPublicSearchTimer = setTimeout(function () {
        const q = ($('#newsSearch').val() || '').trim();
        if (q !== newsPublicLastQuery) {
            newsPublicLastQuery = q;
            newsPublicPage = 1;
        }
        loadNewsPage();
    }, 350);
}

$(document).ready(function () {
    loadNewsPage();

    $('#newsSearch').on('input', scheduleNewsSearch);

    $('#clearNewsFiltersBtn').on('click', function () {
        $('#newsSearch').val('');
        newsPublicLastQuery = '';
        newsPublicPage = 1;
        loadNewsPage();
    });

    $('#newsPagination').on('click', 'a.page-link', function (e) {
        e.preventDefault();
        const $li = $(this).closest('li');
        if ($li.hasClass('disabled') || $li.hasClass('active')) {
            return;
        }
        const p = parseInt($(this).data('page'), 10);
        if (!p || p === newsPublicPage) {
            return;
        }
        newsPublicPage = p;
        loadNewsPage();
    });
});